import { Navigate } from 'react-router-dom';
import { getDefaultPathForRole, getStoredUser, resolveUserRole } from '../utils/authUtils';

/**
 * Renders children only if the current user's role is in allowedRoles.
 * Otherwise redirects to the user's default path.
 */
export default function RequireOneOfRoles({ allowedRoles = [], children }) {
  const user = getStoredUser();
  const role = resolveUserRole(user);
  const allowed = Array.isArray(allowedRoles) && allowedRoles.length > 0 && allowedRoles.includes(role);
  if (allowed) return children;
  return <Navigate to={getDefaultPathForRole(user)} replace />;
}
